/* exported getFinalEligibilityAmount*/
async function getFinalEligibilityAmount(eligibilityAmount) {
	if (eligibilityAmount < 1) {
		return eligibilityAmount;
	}
	const response = await fetch(window.Shopify.routes.root + 'cart.js');
	if (!response.ok) {
		return 0;
	}
	const cartData = await response.json();
	const cartItems = cartData.items;
	const finalEligibilityAmount = cartItems.reduce((accumulator, item) => {
		if (item.properties['_unionPrice']) {
			return accumulator - item.quantity;
		}
		return accumulator;
	}, eligibilityAmount);

	return finalEligibilityAmount;
}
